export default __webpack_public_path__ + "static/bundle2 copia-d23047b3d4deffc790cc68319209f6b1.png";